export default [{
  name: 'restaurantManage',
  path: 'restaurantManage',
  component: () => import('./RestaurantManage.vue'),
  meta: {
    title: '餐厅设置'
  }
}]



// WEBPACK FOOTER //
// ./src/router/restaurant_manage/index.js